import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    travelRatePerKm: Number,
    travelRates: Object
  }

  static targets = ["discountedTravelFee", "distanceFromDepot", "travelFee", "travelFeeDiscount"]

  // outlet API: called by admin--quotes--form via the logistics pricing outlet
  updateYear(year) {
    if (!this.hasTravelRatesValue) return

    this.travelRatePerKmValue = this.travelRatesValue[year] ?? 0
    this.updateTravelFee()
    this.updateDiscountedTravelFee()
  }

  updateTravelFee() {
    this.travelFeeTarget.value =
      this.#distanceFromDepot && this.travelRatePerKmValue ? this.travelRatePerKmValue * this.#distanceFromDepot : ""
    this.travelFeeDiscountTarget.setAttribute("max", this.#travelFee)
  }

  updateDiscountedTravelFee() {
    this.discountedTravelFeeTarget.value = this.#travelFee - this.#travelFeeDiscount
  }

  get #travelFee() {
    return this.#parseOptionalFloat(this.travelFeeTarget)
  }

  get #distanceFromDepot() {
    return this.#parseOptionalFloat(this.distanceFromDepotTarget)
  }

  get #travelFeeDiscount() {
    return this.#parseOptionalFloat(this.travelFeeDiscountTarget)
  }

  #parseOptionalFloat({ value }) {
    return value === "" ? null : parseFloat(value)
  }
}
